import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SectorInfoComponent } from './sector-info/sector-info.component';
import { SectorComponent } from './sector/sector.component';
import { SectorsComponent } from './sectors.component';
import { DepartmentInfoComponent } from './department-info/department-info.component';





const routes: Routes = [
 {path :"",component:SectorsComponent ,children:[
   {path:"Sector",component:SectorComponent},
   {path:"SectorInfo/:id",component:SectorInfoComponent},
   {path:"DepartmentInfo/:id",component:DepartmentInfoComponent},
   {path:"", redirectTo: 'Sector', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class SectorsRoutingModule { }
